module.exports = __webpack_public_path__ + "img/1-min.c5be96ea.png";